export default [
  { name: 'Centimeter', value: 'cm' },
  { name: 'Feet', value: 'ft' },
];
